import { Component, Input } from "@angular/core";
import { MainState } from "@app/store/state";
import { EquipmentItemBaseInterface } from "@features/equipment/types/equipment-item-base.interface";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { BaseComponentDirective } from "@shared/components/base-component.directive";

export enum RemoveRecentlyUsedEquipmentResult {
  CONFIRM,
  CANCEL
}

@Component({
  selector: "astrobin-remove-recently-used-equipment-modal",
  templateUrl: "./remove-recently-used-equipment-modal.component.html",
  styleUrls: ["./remove-recently-used-equipment-modal.component.scss"]
})
export class RemoveRecentlyUsedEquipmentModalComponent extends BaseComponentDirective {
  RemoveRecentlyUsedEquipmentResult = RemoveRecentlyUsedEquipmentResult;

  @Input()
  item: EquipmentItemBaseInterface;

  constructor(
    public readonly store$: Store<MainState>,
    public readonly modal: NgbActiveModal,
    public readonly translateService: TranslateService
  ) {
    super(store$);
  }
}
